<div class="summary-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
  <div class="summary-header">{{header}}</div>
  <div class="summary-value">{{value}}</div>
</div>
